<template>
  <div class="markdown-editor" style="margin-top: 28px; margin-bottom: 20px; position: relative;">
    <label v-model="is_label_active" :focused="focused" :absolute="true" :left="(is_label_active ? 0 : 10)">{{label}}</label>
    <vue-simplemde
      class="dark"
      v-model="val"
      ref="markdownEditor"
      :configs="configs"
    />
  </div>
</template>

<script>
export default {
  props: ['value', 'label'],
  data: () => ({
    focused: false
  }),
  computed: {
    is_label_active() {
      return this.focused || !_.isEmpty(this.value);
    },
    simplemde () {
      return this.$refs.markdownEditor.simplemde;
    },
    configs () {
      return {
        hideIcons: ['side-by-side', 'fullscreen'],
        spellChecker: false,
        status: false
      }
    },
    val: {
      get() {
        return this.value || "";
      },
      set(val) {
        this.$emit("input", val);
      }
    }
  },
  mounted() {
    this.simplemde.codemirror.on('focus', (instance, changeObj) => {
      this.focused = true;
    });
    this.simplemde.codemirror.on('blur', (instance, changeObj) => {
      this.focused = false;
    });
  }
}
</script>
<style>
  /* CodeMirror/SimpleMDE use z-indexes up to 9 internally; keep them inside the editor */
  .markdown-editor {
    isolation: isolate;
  }
  /* SimpleMDE fullscreen is position: fixed inside the editor, so lift the whole editor */
  .markdown-editor:has(.CodeMirror-fullscreen) {
    z-index: var(--ks-z-editor-fullscreen, 2);
  }
  .markdown-editor .v-label {
    -webkit-transform-origin: top left;
    transform-origin: top left;
    top: 60px;
  }
  .markdown-editor .v-label.v-label--active {
    -webkit-transform: translateY(-78px) scale(.75);
    transform: translateY(-78px) scale(.75);
  }

  .markdown-editor .dark {
    color: var(--ks-font-color);
    background-color: transparent;
    border-radius: 5px 5px 0 0;
  }

  .markdown-editor .dark .fa {
    color: white !important;
  } 

  .markdown-editor .editor-preview {
    background: var(--ks-background-color) !important;
  }



  .markdown-editor .editor-toolbar.disabled-for-preview a:not(.no-disable) {
    background-color: transparent !important;
  }

  .markdown-editor .editor-toolbar .active {
    background-color: transparent !important;
    color: var(--ks-col-warning-alternative) !important;
  }


  .markdown-editor .dark .fa:hover {
    color: black !important;
  } 

  .markdown-editor .dark .CodeMirror {
    background-color: transparent;
    color: var(--ks-font-color);
    caret-color: var(--ks-font-color);
  }
  .markdown-editor .CodeMirror-cursor{
    border-left-color: var(--ks-font-color) !important;
  }
  .markdown-editor .CodeMirror-selectedtext {
    color: #000 !important;
/*    background: var(--ks-background-color-light) !important;*/
  }
</style>
